/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { BotsStatus } from '../models/bots-status';
@Injectable({
  providedIn: 'root',
})
class SbbBotsService extends __BaseService {
  static readonly getAllBotsStatusPath = '/sbbBotsStatus';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return get all bots status
   */
  getAllBotsStatusResponse(): __Observable<__StrictHttpResponse<Array<BotsStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/sbbBotsStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BotsStatus>>;
      })
    );
  }
  /**
   * @return get all bots status
   */
  getAllBotsStatus(): __Observable<Array<BotsStatus>> {
    return this.getAllBotsStatusResponse().pipe(
      __map(_r => _r.body as Array<BotsStatus>)
    );
  }
}

module SbbBotsService {
}

export { SbbBotsService }
